import { ClassConstructor, classToPlain, plainToClass } from 'class-transformer';

import deepmerge from 'deepmerge'; // TODO replace this?

function deepMerge<C>(model: ClassConstructor<C>, target: C, partial: Partial<C> | never): C {
  const plainTarget = classToPlain<C>(target);
  const plainPartial = classToPlain<Partial<C>>(partial);
  const plain = deepmerge(plainTarget, plainPartial) as C; // TODO casting == bad

  return plainToClass<C, {}>(model as ClassConstructor<C>, plain);
}
export default deepMerge;
